export const Result = {
  getName: (result) => {
    return result && (result.name_full || result.name);
  }
};
